import * as React from 'react';
import { Loader, Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { useShoppingListById } from '../../../hooks/use-shopping-list-by-id.js';
import Wishlist from './Wishlist.js';

const AnonymousWishlist = ({ isMyAccountEnabled , isUpdateLoading , isAuthLoading , onUpdateWishList , localShoppingListId  })=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    const { data , loading , error  } = useShoppingListById(localShoppingListId);
    const labels = {
        introFull: getLabel('account.wishlist.intro.full'),
        login: getFormattedLabel('account.wishlist.login', {
            parseLink: true
        })
    };
    const onRemoveWishlistItem = (sku)=>{
        onUpdateWishList(sku, data === null || data === void 0 ? void 0 : data.id);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "wishlist-overview"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, getLabel('account.wishlist')), loading || isAuthLoading ? /*#__PURE__*/ React.createElement(Loader, null) : error ? /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        icon: "alert-circle"
    }, getLabel('account.wishlist.error')) : /*#__PURE__*/ React.createElement(Wishlist, {
        wishlistLabels: labels,
        items: data === null || data === void 0 ? void 0 : data.items,
        onUpdateWishList: onRemoveWishlistItem,
        isUpdateLoading: isUpdateLoading,
        isMyAccountEnabled: isMyAccountEnabled
    }));
};

export { AnonymousWishlist as default };
//# sourceMappingURL=AnonymousWishlistOverview.js.map
